import { options } from 'common/components/ContentEditor/options';
import { useContentEditor } from 'common/components/ContentEditor/hooks/useContentEditor';

import { IToolbarButtonProps, ToolbarButton } from './ToolbarButton';
import { LinkDialog } from './LinkDialog';
import { useLinkDialogState } from './useLinkDialogState';

export const ToolbarLink = (props: IToolbarButtonProps) => {
    const editor = useContentEditor();
    const { open, initialValue, onTrigger, onClose, onSubmit } =
        useLinkDialogState(editor);

    return (
        <>
            <ToolbarButton
                active={editor.api.some({
                    match: { type: options.link.type },
                })}
                onMouseDown={(event) => {
                    event.preventDefault();

                    if (!editor.selection) return;

                    onTrigger();
                }}
                {...props}
            />
            <LinkDialog
                initialValue={initialValue}
                open={open}
                onClose={onClose}
                onSubmit={onSubmit}
            />
        </>
    );
};
